import classes from './Onboarding.module.scss';
import { BonusTooltip } from './tooltips/BonusTooltip';

export const DailyBonusOnboarding = () => {
  return (
    <div>
      <div className={classes.cover}></div>
      <div className={classes.bonusLabel + ' onboarding-arrow'}>
        <BonusTooltip />
      </div>
    </div>
  );
};
